// Moment.js Lao locale configuration
export default {
  months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
  monthsShort: 'ມ.ກ._ກ.ພ._ມີ.ນ._ມ.ສ._ພ.ພ._ມິ.ຖ._ກ.ລ._ສ.ຫ._ກ.ຍ._ຕ.ລ._ພ.ຈ._ທ.ວ.'.split('_'),
  monthsParseExact: true,
  weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
  weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
  weekdaysMin: 'ທ_ຈ_ອ_ພ_ພຫ_ສ_ສ'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
  },
  calendar: {
    sameDay: '[ມື້ນີ້ເວລາ] LT',
    nextDay: '[ມື້ອື່ນເວລາ] LT',
    nextWeek: 'dddd[ໜ້າເວລາ] LT',
    lastDay: '[ມື້ວານນີ້ເວລາ] LT',
    lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
    sameElse: 'L'
  },
  relativeTime: {
    future: 'ອີກ %s',
    past: '%sກ່ອນ',
    s: 'ບໍ່ເທົ່າໃດວິນາທີ',
    ss: '%d ວິນາທີ',
    m: 'ໜຶ່ງນາທີ',
    mm: '%d ນາທີ',
    h: 'ໜຶ່ງຊົ່ວໂມງ',
    hh: '%d ຊົ່ວໂມງ',
    d: 'ໜຶ່ງມື້',
    dd: '%d ມື້',
    M: 'ໜຶ່ງເດືອນ',
    MM: '%d ເດືອນ',
    y: 'ໜຶ່ງປີ',
    yy: '%d ປີ'
  },
  dayOfMonthOrdinalParse: /\d{1,2}/,
  ordinal: function (number) {
    return number;
  },
  meridiemParse: /ກ່ອນທ່ຽງ|ຫຼັງທ່ຽງ/,
  isPM: function (input) {
    return input === 'ຫຼັງທ່ຽງ';
  },
  meridiem: function (hour, minute, isLower) {
    if (hour < 12) {
      return 'ກ່ອນທ່ຽງ';
    } else {
      return 'ຫຼັງທ່ຽງ';
    }
  },
  week: {
    dow: 0, // Sunday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  }
};
